import { memo } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FiltersFooterProps {
  onCancel: () => void;
  onDone: () => void;
  onClearAll: () => void;
}

export const FiltersFooter = memo(
  ({ onCancel, onDone, onClearAll }: FiltersFooterProps) => {
    return (
      <div className="mt-2 flex items-center justify-between border-t border-border pt-4">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            onClick={onCancel}
            className="cursor-pointer text-muted-foreground hover:text-foreground"
          >
            Cancel
          </Button>
          <Button
            onClick={onDone}
            className="cursor-pointer rounded-full bg-primary px-8 text-primary-foreground hover:bg-primary/90"
          >
            Done
          </Button>
        </div>

        <Button
          variant="destructive"
          onClick={onClearAll}
          className="cursor-pointer rounded-[18px] px-2.5 py-2"
        >
          <Trash2 className="mr-0.5 h-4 w-4" />
          Delete
        </Button>
      </div>
    );
  },
);

FiltersFooter.displayName = "FiltersFooter";
